const RELOAD_FLAG_KEY = "qh:chunk-load-reload-at";
const RELOAD_COOLDOWN_MS = 10_000;

/**
 * Detects Vite/browser failures when a stale tab tries to load a JS chunk
 * that was removed by a new deploy (hashed filenames change).
 */
export function isChunkLoadError(error: unknown): boolean {
  const message = error instanceof Error ? error.message : String(error ?? "");
  return (
    /Failed to fetch dynamically imported module/i.test(message) ||
    /error loading dynamically imported module/i.test(message) ||
    /Importing a module script failed/i.test(message) ||
    /Loading chunk [\d]+ failed/i.test(message)
  );
}

/**
 * Reloads once to pick up the new deploy. Returns true if a reload was
 * triggered. A short cooldown prevents infinite reload loops.
 */
export function tryReloadOnChunkError(error: unknown): boolean {
  if (!isChunkLoadError(error)) {
    return false;
  }

  const now = Date.now();
  let lastReloadAt: number;
  try {
    lastReloadAt = Number(sessionStorage.getItem(RELOAD_FLAG_KEY) || "0");
  } catch {
    return false;
  }

  if (now - lastReloadAt < RELOAD_COOLDOWN_MS) {
    return false;
  }

  try {
    sessionStorage.setItem(RELOAD_FLAG_KEY, String(now));
  } catch {
    return false;
  }
  window.location.reload();
  return true;
}

export function clearChunkLoadReloadFlag(): void {
  try {
    sessionStorage.removeItem(RELOAD_FLAG_KEY);
  } catch {
    // Storage may be unavailable; there is no persisted flag to clear.
  }
}
